import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH,
  PASSWORD_UPPERCASE_RE,
  PASSWORD_LOWERCASE_RE,
  PASSWORD_DIGIT_RE,
} from './constants'

export function usernameRules(t) {
  return [
    v => !!v || t('form.rules.required'),
    v => (v && v.length >= 3) || t('form.rules.text_too_short'),
    v => (v && v.length <= 20) || t('form.rules.text_too_long'),
  ]
}

export const PASSWORD_REQUIREMENTS = [
  {
    key: 'min_length',
    test: v => !!v && v.length >= PASSWORD_MIN_LENGTH,
    params: { min: PASSWORD_MIN_LENGTH },
  },
  {
    key: 'uppercase',
    test: v => PASSWORD_UPPERCASE_RE.test(v ?? ''),
  },
  {
    key: 'lowercase',
    test: v => PASSWORD_LOWERCASE_RE.test(v ?? ''),
  },
  {
    key: 'digit',
    test: v => PASSWORD_DIGIT_RE.test(v ?? ''),
  },
]

export function passwordRules(t) {
  return [
    v => !!v || t('form.rules.required'),
    ...PASSWORD_REQUIREMENTS.map(req =>
      v => req.test(v) || t(`form.password_requirements.${req.key}`, req.params ?? {})
    ),
    v => (v && v.length <= PASSWORD_MAX_LENGTH) || t('form.rules.text_too_long'),
  ]
}
